import { Id } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { MemberCard } from 'chat/members/views/card'
import { MembersList } from 'chat/members/views/list'
import React, { useMemo } from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Reader } from './types'

interface Props {
  readers: Reader[] | undefined
  memberCount: number | undefined
}

export function ReadersView({ readers, memberCount }: Props) {
  const styles = useStyles()
  const members = useMemo(() => readers?.map(r => r.member), [readers])

  const readAtMap = useMemo(
    () =>
      readers?.reduce<Record<Id, Date>>(
        (map, reader) => ({
          ...map,
          [reader.member.id]: new Date(reader.timestamp),
        }),
        {}
      ),
    [readers]
  )

  if (!readers) {
    return null
  }

  if (readers.length === 0) {
    return (
      <View style={styles.emptyContainer}>
        <Text>{t('noReaders')}</Text>
      </View>
    )
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View style={styles.summary}>
          <Text style={styles.summaryText}>
            {t('readBySummary', {
              current: members?.length,
              total: memberCount,
            })}
          </Text>
        </View>
        <MembersList
          members={members ?? []}
          renderItem={({ item: member }) => (
            <MemberCard member={member} readAt={readAtMap?.[member.id]} />
          )}
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    padding: 10,
  },
  emptyContainer: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    justifyContent: 'center',
    alignItems: 'center',
  },
  summary: {
    padding: 10,
    marginBottom: 10,
    borderRadius: 5,
    backgroundColor: theme.colors?.grey7,
    justifyContent: 'center',
    alignItems: 'center',
  },
  summaryText: {
    color: theme.colors?.grey1,
  },
}))
